module.exports = "<img src=\"assets/img/core_Site/heartbullet.png\" alt=\"careing heart\" />\n"